module.exports = __webpack_public_path__ + "img/full02.eaf07748.png";